import React from 'react';
import { useTranslation } from 'react-i18next';
import { SCOPE_INBOUND_COLOR, SCOPE_OUTBOUND_COLOR } from './graphColors';
import { MemberConnections } from './graphTypes';
import styles from './SocialGraphPOC.module.scss';

// Stacked lines under an actor's name, one per direction that has any
// connections, with the direction glyphs: "● 11 Inbound – 500 interactions"
// (design 2026-10-16: directions with nothing are left out, so a one-way
// relation is a single line). Used by every group-panel member row (full
// split) and by the Actor panel's Connections-tab rows (the pair's inbound /
// outbound only — a mutual pair is simply both lines).
export const MemberConnectionsLine: React.FC<{
  connections: Partial<MemberConnections>;
}> = ({ connections }) => {
  const { t } = useTranslation();
  const lines = [
    {
      key: 'in',
      stat: connections.inbound,
      label: (count: number) => t('{{count}} inbound', { count }),
      glyph: (
        <span
          className={styles.connectionRowDot}
          style={{ backgroundColor: SCOPE_INBOUND_COLOR }}
          aria-hidden="true"
        />
      ),
    },
    {
      key: 'out',
      stat: connections.outbound,
      label: (count: number) => t('{{count}} outbound', { count }),
      glyph: (
        <span
          className={styles.connectionRowDot}
          style={{ backgroundColor: SCOPE_OUTBOUND_COLOR }}
          aria-hidden="true"
        />
      ),
    },
    {
      key: 'mutual',
      stat: connections.mutual,
      label: (count: number) => t('{{count}} mutual', { count }),
      glyph: (
        <span className={styles.connectionRowPair} aria-hidden="true">
          <span />
          <span />
        </span>
      ),
    },
  ];
  return (
    <>
      {lines.map(({ key, stat, label, glyph }) =>
        stat && stat.connections > 0 ? (
          <span key={key} className={styles.connectionRowSub}>
            {glyph}
            {`${label(stat.connections)} – ${t('{{count}} interactions', {
              count: stat.interactions,
            })}`}
          </span>
        ) : null,
      )}
    </>
  );
};
